import { render, staticRenderFns } from "./solitario.vue?vue&type=template&id=73d23ae4"
import script from "./solitario.vue?vue&type=script&lang=js"
export * from "./solitario.vue?vue&type=script&lang=js"
import style0 from "./solitario.vue?vue&type=style&index=0&id=73d23ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports